'use client'

import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'

import { openReplayTracker } from '@/components/private/openreplay'
import { ECookies } from '@/libs/hooks/use-cookies'

interface DeviceIDHookResult {
  loading: boolean
}

export default function useDeviceGuid(): DeviceIDHookResult {
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    async function fetchDeviceID() {
      try {
        const fp = await FingerprintJS.load()
        const result = await fp.get()

        Cookies.set(ECookies.deviceGUID, result?.visitorId)
        openReplayTracker.setMetadata('deviceGUID', result?.visitorId)
      } finally {
        setLoading(false)
      }
    }

    if (typeof window !== 'undefined') {
      fetchDeviceID()
    }
  }, [])

  return { loading }
}
